import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
var colors = tokens.colors;
export var DEFAULT_LOGO_HEIGHT = '22px';
export var TWENTY_FIVE_YEARS_LOGO_HEIGHT = '33px';
export var header = /*#__PURE__*/css("background-color:", colors.neutral.surface.default, ";display:flex;");
export var headerDesktop = {
  name: "167lj4j",
  styles: "height:64px;"
};